<template>
  <div class="admin-list">
    <div class="header">
      <h1>商品管理</h1>
      <button class="btn-add" @click="goToEdit()">+ 添加商品</button>
    </div>
    
    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else-if="products.length === 0" class="empty">暂无商品，请添加</div>
    <div v-else class="product-list">
      <div v-for="product in products" :key="product.id" class="product-item">
        <div class="thumb-container">
          <img v-if="product.coverImage" :src="product.coverImage" alt="" class="thumb">
          <div v-else class="thumb-placeholder">暂无</div>
        </div>
        <div class="info">
          <div class="title">{{ product.dollNumber }} - {{ product.name }}</div>
          <span class="status" :class="product.status">{{ product.status === 'onSale' ? '在售' : '下架' }}</span>
        </div>
        <div class="actions">
          <button class="btn-toggle" @click="toggleStatus(product)">
            {{ product.status === 'onSale' ? '下架' : '上架' }}
          </button>
          <button class="btn-edit" @click="goToEdit(product.id)">编辑</button>
          <button class="btn-delete" @click="deleteProduct(product.id)">删除</button>
        </div>
      </div>
    </div>
    
    <div class="nav">
      <button class="btn-nav" @click="$router.push('/')">← 返回首页</button>
    </div>
  </div>
</template>

<script>
import { productApi } from '../api';

export default {
  name: 'AdminList',
  data() {
    return {
      products: [],
      loading: true,
      error: ''
    };
  },
  mounted() {
    this.loadProducts();
  },
  watch: {
    '$route': {
      handler() {
        this.loadProducts();
      },
      immediate: true
    }
  },
  methods: {
    async loadProducts() {
      this.loading = true;
      this.error = '';
      try {
        console.log('开始加载产品列表...');
        const res = await productApi.getList();
        console.log('API 响应:', res);
        if (res.data.code === 200) {
          this.products = res.data.data;
          console.log('产品列表:', this.products);
        } else {
          this.error = res.data.message || '加载失败';
        }
      } catch (e) {
        console.error('加载失败:', e);
        this.error = '网络错误，请检查后端服务器是否运行';
      } finally {
        this.loading = false;
      }
    },
    async toggleStatus(product) {
      const newStatus = product.status === 'onSale' ? 'offSale' : 'onSale';
      try {
        await productApi.updateStatus(product.id, newStatus);
        product.status = newStatus;
      } catch (e) {
        alert('操作失败');
      }
    },
    async deleteProduct(id) {
      if (!confirm('确定要删除吗？')) return;
      try {
        await productApi.delete(id);
        this.loadProducts();
      } catch (e) {
        alert('删除失败');
      }
    },
    goToEdit(id) {
      this.$router.push({ name: 'AdminEdit', params: { id } });
    }
  }
};
</script>

<style scoped>
.admin-list {
  padding: 20px;
  background: #F9F7F5;
  min-height: 100vh;
}

.loading, .error, .empty {
  text-align: center;
  padding: 40px;
  color: #666;
}

.error {
  color: #ff4444;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header h1 {
  font-size: 24px;
}

.btn-add {
  padding: 10px 20px;
  background: #A8E6CF;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.product-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
}

.thumb-container {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}

.thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
}

.thumb-placeholder {
  width: 80px;
  height: 80px;
  background: #f0f0f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

.info {
  flex: 1;
}

.title {
  font-size: 16px;
  margin-bottom: 8px;
}

.status {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.status.onSale {
  background: #A8E6CF;
}

.status.offSale {
  background: #FFD3B6;
}

.actions {
  display: flex;
  gap: 8px;
}

.actions button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.btn-toggle {
  background: #ddd;
}

.btn-edit {
  background: #d0e8ff;
}

.btn-delete {
  background: #ffd0d0;
}

.nav {
  margin-top: 24px;
}

.btn-nav {
  padding: 12px 24px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
}
</style>
